export enum GetAllAttributes {
  Request = 'GET_ALL_ATTRIBUTES_REQUEST',
  Success = 'GET_ALL_ATTRIBUTES_SUCCESS',
  Failed = 'GET_ALL_ATTRIBUTES_FAILED',
}

export enum GetAttributes {
  Request = 'GET_ATTRIBUTES_REQUEST',
  Success = 'GET_ATTRIBUTES_SUCCESS',
  Failed = 'GET_ATTRIBUTES_FAILED',
}

export enum GetSingleAttribute {
  Request = 'GET_SINGLE_ATTRIBUTE_REQUEST',
  Success = 'GET_SINGLE_ATTRIBUTE_SUCCESS',
  Failed = 'GET_SINGLE_ATTRIBUTE_FAILED',
}

export enum GetAttributesSearch {
  Request = 'GET_ATTRIBUTES_SEARCH_REQUEST',
  Success = 'GET_ATTRIBUTES_SEARCH_SUCCESS',
  Failed = 'GET_ATTRIBUTES_SEARCH_FAILED',
}

export enum AddAttribute {
  Request = 'ADD_ATTRIBUTE_REQUEST',
  Success = 'ADD_ATTRIBUTE_SUCCESS',
  Failed = 'ADD_ATTRIBUTE_FAILED',
}

export enum EditAttribute {
  Request = 'EDIT_ATTRIBUTE_REQUEST',
  Success = 'EDIT_ATTRIBUTE_SUCCESS',
  Failed = 'EDIT_ATTRIBUTE_FAILED',
}

export enum EditAttributePrivacy {
  Request = 'EDIT_ATTRIBUTE_PRIVACY_REQUEST',
  Success = 'EDIT_ATTRIBUTE_PRIVACY_SUCCESS',
  Failed = 'EDIT_ATTRIBUTE_PRIVACY_FAILED',
}

export enum DeleteAttribute {
  Request = 'DELETE_ATTRIBUTE_REQUEST',
  Success = 'DELETE_ATTRIBUTE_SUCCESS',
  Failed = 'DELETE_ATTRIBUTE_FAILED',
}

export enum AddValue {
  Request = 'ADD_VALUE_REQUEST',
  Success = 'ADD_VALUE_SUCCESS',
  Failed = 'ADD_VALUE_FAILED',
}

export enum UsersAttributesCheck {
  Request = 'USERS_ATTRIBUTES_CHECK_REQUEST',
  Success = 'USERS_ATTRIBUTES_CHECK_SUCCESS',
  Failed = 'USERS_ATTRIBUTES_CHECK_FAILED',
}

export enum ChangeAttrOption {
  Request = 'CHANGE_ATTR_OPTION_REQUEST',
  Success = 'CHANGE_ATTR_OPTION_SUCCESS',
  Failed = 'CHANGE_ATTR_OPTION_FAILED',
}

export enum EditValue {
  Request = 'EDIT_VALUE_REQUEST',
  Success = 'EDIT_VALUE_SUCCESS',
  Failed = 'EDIT_VALUE_FAILED',
}

export enum DeleteValue {
  Request = 'DELETE_VALUE_REQUEST',
  Success = 'DELETE_VALUE_SUCCESS',
  Failed = 'DELETE_VALUE_FAILED',
}

export const NEW_VALUE_LIST = 'NEW_VALUE_LIST';
export const RESET_ATTRIBUTES = 'RESET_ATTRIBUTES';
